import React from 'react';
import Footer from '~/components/footer';
import Loading from '~/components/loading/loading';
import NotFound from '~/components/not-found/index';
import axios from "axios";
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as currencyFormatter from 'currency-formatter';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import moment from 'moment';
import makeAnimated from "react-select/animated";

import { getMessage, system_lang, convertCentsToFloat } from '~/assets/utils';
import {
    getProductsCart, removeAllProductFromCart, removeProductFromCart, addProductToCart, getAddressDelivery, createOrder,
    getCupoms,
    updateCart
} from '../../assets/requests/product';
import { getFirebaseData } from '~/firebase/functions';

const animatedComponents = makeAnimated();
class ShoppingCart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message_load: 'loading_products',
            loaded: false,
            products: [],
            attributes: [],
            total_price: 0,
            zip_code: '',
            orders_available: true,
            fare_price: 0,
            loadingFare: false,
            deliveryMode: 1,
            observation: '',
            loadingCupom: false,
            cupom: '',
            percentage: 0,
            currency: 0,
            cupom_error: '',
            colors: [],
            colorsAttributes: [],
            list: '',
            quinzena: []
        }

        /**
         * Pega o nome de uma cor
         * @param {*} attributeKey 
         */
        this.getColorName = (colorKey) => {
            const { colors } = this.state;
            if (!colors) return false;
            const color = colors.find(item => item.colorKey === colorKey);
            if (color) {
                return color.name;
            }
            else {
                return false;
            }
        }

        this.handleChange = async (e) => {
            try {
                const state = Object.assign({}, this.state);
                state[e.target.name] = e.target.value;
                await this.setState(state);
                if (parseInt(e.target.value) === 1) {
                    let response = {
                        data: {}
                    };
                    let discount = 0;
                    if (this.state.currency > 0) {
                        discount = this.state.currency;
                    }
                    else if (this.state.percentage > 0) {
                        discount = this.state.percentage;
                    }
                    response.data.total_price = this.state.total_price;
                    response.data.zip_code = state.zip_code;
                    response.data.fare_price = 0;
                    response.data.national_identification = '';
                    response.data.national_identification_email = '';
                    response.data.national_identification_name = '';
                    response.data.deliveryMode = 1;
                    response.data.orders_available = true;
                    response.data.discount = discount;
                    this.props.dispatch({ type: 'SET_FREIGHT_DATA', data: response.data })
                    this.setState({ fare_price: 0, loadingFare: false, orders_available: true });
                } else {
                    this.handleChangeZip(state.zip_code);
                }
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        /**
         * Gera as observações do usuário
         * @param {*} e 
         */
        this.observationChange = (e) => {
            this.setState({observation: e.target.value})
        }
        /**
         * Função para pegar a próxima quinzena
         */
        this.scheduling = () => {
            let quinzena = moment(new Date(), "YYYY-MM-DD").add(1, 'months');
            let sixMonths = moment(quinzena).add(6, 'months');
            const days = sixMonths.diff(quinzena, 'days');
            const dia = quinzena.get('date');
            if (dia < 15) {
                quinzena.add((15 - dia), 'days');
            }

            let list = [];
            for (let i = 0; i <= days; i++) {
                list.push({
                    value: moment(quinzena).add(i, 'days').format('YYYY-MM-DD'),
                    label: moment(quinzena).add(i, 'days').format('DD/MM/YYYY')
                 })
            }

            return list;
        }
        /**
         * Envia a data para o DB
         * @param {*} data 
         */
        this.onChangeSelect = (data) => {
            try {
              const quinzena = data
              const listDate = data.value 
              this.setState({quinzena, listDate})
            } catch (error) {
                alert(error.message)
            }
        }
        this.calcTotalPrice = (total_price) => {
            try {
                let price = 0;
                let discontoPorValor = this.state.currency;
                let discontoPorPorcentagem = this.state.percentage;

                if (discontoPorValor > 0) {
                    total_price = total_price / 100;
                    discontoPorValor = discontoPorValor / 100;
                    price = total_price - discontoPorValor;
                } else if (discontoPorPorcentagem > 0) {
                    let discount = (total_price * (discontoPorPorcentagem / 100)) / 100;
                    let prevPrice = total_price / 100;
                    price = prevPrice - discount;
                } else {
                    price = total_price / 100;
                }

                price = price > 0 ? price : 0;

                return Number(price.toFixed(2));
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.calcTotalDiscount = (total_price) => {
            try {
                let price = 0;
                let discontoPorValor = this.state.currency;
                let discontoPorPorcentagem = this.state.percentage;

                if (discontoPorValor > 0) {
                    price = discontoPorValor / 100;
                } else if (discontoPorPorcentagem > 0) {
                    let discount = (total_price * (discontoPorPorcentagem / 100)) / 100;
                    price = discount;
                }

                price = price > 0 ? price : 0;

                return Number(price.toFixed(2));
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.handleChangeZip = async (zip_code) => {
            try {
                this.setState({ loadingFare: true });
                let orders_available = false;
                let fare_price = 0;
                let data_order = {};
                zip_code = zip_code.toString();
                if (zip_code.match(/\d/g) && zip_code.match(/\d/g).join('').length === 8) {
                    let response = await getAddressDelivery(zip_code.match(/\d/g).join(''));
                    if (response.status === true) {
                        fare_price = convertCentsToFloat(response.data.farePrice);
                        if (parseInt(this.state.deliveryMode) === 1) {
                            fare_price = 0;
                        }

                        let discount = 0;
                        if (this.state.currency > 0) {
                            discount = this.state.currency;
                        }
                        else if (this.state.percentage > 0) {
                            discount = this.state.percentage;
                        }

                        response.data.deliveryMode = this.state.deliveryMode;
                        orders_available = true;
                        response.data.total_price = this.state.total_price;
                        response.data.zip_code = zip_code.match(/\d/g).join('');
                        response.data.fare_price = fare_price;
                        response.data.national_identification = '';
                        response.data.national_identification_email = '';
                        response.data.national_identification_name = '';
                        response.data.observation = this.state.observation;
                        response.data.discount = discount;
                        this.props.dispatch({ type: 'SET_FREIGHT_DATA', data: response.data })
                    }
                }
                this.setState({ zip_code, orders_available, fare_price, data_order, loadingFare: false, loaded: true });
            }
            catch (error) {
                this.setState({ loadingFare: false });
                this.props.alert.error(error.message);
                return;
            }
        }
        this.handleChangeCupom = async (cupom) => {
            try {
                cupom = cupom.toUpperCase();
                let cupom_error = '';
                this.setState({ cupom })
                if (cupom.toString().length >= 3) {
                    const discounts = this.state.cupoms;
                    let indexOf = discounts.findIndex(item => item.code === cupom && item.status === 1);
                    if (indexOf >= 0 && (discounts[indexOf].used < discounts[indexOf].quantity) && (discounts[indexOf].dateEnd > new Date().getTime())) {
                        if (discounts[indexOf].valueCurrency > 0) {
                            this.setState({ currency: discounts[indexOf].valueCurrency, percentage: 0, loadingCupom: false, cupom_error, discountId: discounts[indexOf]._id });
                        } else if (discounts[indexOf].valuePorcentage > 0) {
                            this.setState({ percentage: discounts[indexOf].valuePorcentage, currency: 0, loadingCupom: false, cupom_error, discountId: discounts[indexOf]._id });
                        }
                        return true;
                    } else {
                        cupom_error = 'cupom_expired';
                    }
                    this.setState({ loadingCupom: false, currency: 0, percentage: 0, cupom_error, discountId: null });
                } else {
                    this.setState({ loadingCupom: false, currency: 0, percentage: 0, cupom_error, discountId: null });
                }
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.getProductsCart = async () => {
            try {
                let response2 = await getCupoms();
                if (response2.status === true) {
                    this.setState({ cupoms: response2.data })
                }
                else {
                    this.setState({ cupoms: [] });
                }
                let response = await getProductsCart();
                if (response.status === true) {
                    this.setState({ products: response.products, attributes: response.attributes, total_price: response.total_price }, () => {
                        this.handleChange({
                            target: {
                                name: 'deliveryMode',
                                value: '1'
                            }
                        })
                    });
                }
                this.setState({ message_load: 'all_is_ready', loaded: true });
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.removeAll = async (product_id) => {
            try {
                updateCart(product_id, []);
                this.getProductsCart();
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.subtractProduct = async (product_key) => {
            try {
                const products = Object.assign([], this.state.products);
                let product = products[product_key];
                let quantity = product.quantity;
                if (quantity > 1) {
                    let productData = {
                        product_id: product._id,
                        attribute_id: product.attribute_selected._id,
                        attribute_value: product.attribute_selected.value,
                    }
                    let response = await removeProductFromCart(productData);
                    if (response.status === true) {
                        product.quantity -= 1;
                        products[product_key] = product;
                        let total_price = this.state.total_price - (this.state.products[product_key].price || 0);
                        this.setState({ products, total_price });
                    }
                } else if (quantity === 1) {
                    this.removeAll(product._id, product.attribute_selected._id, product.attribute_selected.value, product_key);
                }
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.addProduct = async (product_key) => {
            try {
                const products = Object.assign([], this.state.products);
                let product = products[product_key];

                let productData = {
                    product_id: product._id,
                    attributeKey: product.attribute_selected._id,
                    childrenKey: product.attribute_selected.value,
                    colorKey: product.colorKey
                }
                let response = await addProductToCart(productData, this.state.colorsAttributes);
                if (response.status === true) {
                    product.quantity += 1;
                    products[product_key] = product;
                    let total_price = this.state.total_price + (this.state.products[product_key].price || 0);
                    this.setState({ products, total_price });
                }
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.seeProduct = (product_id, e) => {
            try {
                e.preventDefault();
                this.props.history.push('/product/' + product_id);
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        /**
         * Verifica o total de itens selecionados
         * @param {*} item 
         */
        this.getAttributeTotal = (itemData) => {
            try {
                if (!itemData.quantity) return 0;

                return itemData.quantity;

            }
            catch (error) {
                return 0;
            }
        }
        /**
         * Atualiza o carrinho com o novo produto
         * @param {*} product_id 
         * @param {*} attributes 
         */
        this.setCart = async (product_id, attributes) => {
            try {
                updateCart(product_id, attributes);
                let total_price = 0;
                let prevProducts = Object.assign([], this.state.products);
                prevProducts.forEach((item, key) => {
                    const prevAttributes = item.attributes.filter(item2 => item2.quantity > 0);
                    prevProducts[key].attributes = prevAttributes;
                });
                const products = prevProducts.filter(item => item.attributes.length > 0);

                products.forEach(product => {
                    product.attributes.forEach(item => {
                        total_price += (product.price * item.quantity);
                    });
                })

                this.setState({ products, total_price });
            }
            catch (error) {
                return false;
            }
        }
        /**
         * Adiciona mais produtos ao item do carrinho
         * @param {*} product_id 
         * @param {*} attributes 
         */
        this.addMoreItems = async (product_id, attributes) => {
            try {
                let products = Object.assign([], this.state.products);
                const indexOf = products.findIndex(item => item._id === product_id);
                if (indexOf < 0) return false;

                products[indexOf].attributes = attributes;
                this.setState({ products }, () => this.setCart(product_id, attributes));
            }
            catch (error) {
                return false;
            }
        }
        /**
         * Altera o total de atributos selecionados
         * @param {*} e 
         */
        this.changeTotalSelected = async (e, itemData, product_id, prevAttributes) => {
            try {
                if (e.target.value === '-1') {
                    e.target.value = 0;
                }

                const indexOf = prevAttributes.findIndex(item => {
                    if ((item.attributeKey === itemData.attributeKey) && (item.childrenKey === itemData.childrenKey) && (item.colorKey === itemData.colorKey)) {
                        return item;
                    }
                });

                const quantity = parseInt(e.target.value);
                let attributes = Object.assign([], prevAttributes);

                if (indexOf < 0) {
                    attributes.push({
                        ...itemData,
                        quantity
                    });
                }
                else {
                    attributes[indexOf].quantity = quantity;
                }

                this.addMoreItems(product_id, attributes);
            }
            catch (error) {
                return false;
            }
        }
        /**
         * Renderiza as cores de cada atributo
         * @param {*} item 
         * @param {*} key 
         */
        this.renderAttributeColor = (item, attributes, listAttributes, productId, attributesQuantity) => {
            try {
                let html = [];
                listAttributes.map((attribute, position) => {
                    let quantity = 0;
                    const indexOf = attributesQuantity.findIndex(item2 => item2.childrenKey === attribute.childrenKey && item2.colorKey === item.colorKey);
                    if (indexOf >= 0) quantity = attributesQuantity[indexOf].quantity;

                    html.push(
                        <div style={{
                            width: '100%',
                            maxWidth: '110px'
                        }} key={position}>
                            <div className='counter d-flex mb-0' style={{
                                background: '#e7e7e7',
                                borderRight: 'solid 1px #cecece',
                                height: '100%',
                                borderBottom: 'solid 1px #cecece'
                            }}>
                                <div className='counter-total m-auto' style={{ background: '#e6e6e6', width: '100%' }}>
                                    <input
                                        type='number'
                                        style={{maxWidth: '100%', margin: 'auto'}}
                                        value={quantity}
                                        name={new Date().getTime()}
                                        onChange={(e) => this.changeTotalSelected(e, {
                                            ...attribute,
                                            colorKey: item.colorKey,
                                            quantity: quantity
                                        }, productId, attributesQuantity)} />
                                </div>
                            </div>
                        </div>
                    )
                });
                return html;
            }
            catch (error) {
                return '';
            }
        }
        /**
         * Carrega os atributos
         */
        this.renderAttributes = (attributes, productId, colors, attributes2) => {
            try {
                if (!attributes) return false;

                let listAttributes = [];
                attributes.map(item => {
                    const indexOf = listAttributes.findIndex(item2 => item2.childrenKey === item.childrenKey);
                    if (indexOf < 0) listAttributes.push(item);
                });

                return (
                    <div className='attribute-wrapper'>
                        <div className='row'>
                            <div className='col-12 col-lg-3 pr-lg-0'></div>
                            <div className='col-12 col-lg-9 pl-lg-0'>
                                <div className='row table' style={{zoom: '75%'}}>
                                    <div className='header-table col-12'>
                                        <div className='row'>
                                            <div className='col-2'></div>
                                            <div className='col-10'>
                                                <div className='row'>
                                                    {listAttributes.map((item, key) => {
                                                        return (<div className='item-header' key={key}>{item.name}</div>)
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='body-table col-12'>
                                        <div className='row'>
                                            <div className='col-2'>
                                                {colors.map((item, key) => {
                                                    return (<div className='item-body' key={key}>{item.name}</div>)
                                                })}
                                            </div>
                                            <div className='col-10'>
                                                {colors.map((item, key) => {
                                                    return (
                                                        <div className='row' style={{height: '44.5px'}} key={key}>
                                                            {this.renderAttributeColor(item, attributes, listAttributes, productId, attributes2)}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
            catch (error) {
                return false;
            }
        }
        this.loadProduct = () => {
            try {
                let products_list = [];
                const { products } = this.state
                products.map((product, key) => {
                    products_list.push(
                        <div className='cart-product row pt-4' key={key} style={{
                            background: '#f1f1f1',
                            padding: '10px',
                            borderBottom: 'solid 1px #dedede'
                        }}>
                            <div className='col-12 col-md-6 col-lg-7 col-xl-5 mb-2'>
                                <div className='media m-auto d-flex flex-wrap'>
                                    <a className='thumbnail pull-left d-block d-lg-inline-block col-12 col-lg-3 text-center' href={process.env.REACT_APP_URL + '/product/' + product._id} onClick={(e) => this.seeProduct(product._id, e)}>
                                        <img className='media-object img-fluid' alt={process.env.REACT_APP_NAME} src={product.images[0].url} />
                                    </a>
                                    <div className='media-body col-12 col-lg-9 text-center text-lg-left'>
                                        <h4 className='media-heading'>
                                            <a href={process.env.REACT_APP_URL + '/product/' + product._id} onClick={(e) => this.seeProduct(product._id, e)}>{product.name}</a>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-5 col-xl-6 mb-4 mb-0'>
                                <div className='row'>
                                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-auto order-4 ml-auto'>
                                        <button type='button' className='btn btn-danger w-100' onClick={() => this.removeAll(product._id)}>{getMessage('remove_from_cart')}</button>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-6 col-xl-6 mb-4 mb-0'>
                                <div className='product-details'>
                                    {this.renderAttributes(product.weights, product._id, product.colors, product.attributes)}
                                </div>
                            </div>
                        </div>
                    )
                    return true;
                });
                return products_list;
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.goToHome = () => {
            try {
                this.props.history.push('/');
            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
        this.userSession = () => {
            this.setState({ user: this.props.user });
        }
        this.seePayment = async () => {
            try {
                let discount = 0;
                if (this.state.currency > 0) {
                    discount = this.state.currency;
                }
                else if (this.state.percentage > 0) {
                    discount = this.calcTotalDiscount(this.state.total_price) * 100;
                }
                localStorage.removeItem('order_id');

                const sendEmailURL = "https://us-central1-tookas-55a71.cloudfunctions.net/sendEmail";
                
                axios
                  .post(
                    sendEmailURL,
                    {
                      text: "Pedido",
                      subject: "Novo pedido efetuado!",
                      from: "Loja Tookas",
                      email: "sac@tookas.com.br",
                    },
                    { headers: { "Content-Type": "application/json" } }
                  )
                  .then((res) => {
                    if (res.data.success === true) {
                      this.props.history.push("/payment", {
                        discount: discount,
                        discountId: this.state.discountId || null,
                        observation: this.state.observation,
                        quinzena: this.state.quinzena,
                      });
                    }
                  });

            }
            catch (error) {
                this.props.alert.error(error.message);
                return;
            }
        }
    }

    /**
     * Carrega as cores do produto
     */
    loadColors = async () => {
        let response = await getFirebaseData(`colors`);
        if (response.status === true) {
            response = response.data;
            let colors = [];
            if (response) {
                Object.keys(response).map(colorKey => {
                    colors.push({
                        colorKey: colorKey,
                        ...response[colorKey]
                    })
                });
            }
            this.setState({ colors: colors });
        }
        response = await getFirebaseData(`colors-attributes`);
        if (response.status === true) {
            response = response.data;
            let colorsAttributes = [];
            if (response) {
                Object.keys(response).map(key => {
                    Object.keys(response[key]).map(key2 => {
                        colorsAttributes.push({
                            key: key2,
                            ...response[key][key2]
                        })
                    })
                });
            }
            this.setState({ colorsAttributes: colorsAttributes });
        }
    }

    componentDidMount() {
        document.querySelector('body').classList.remove('scroll-false');
        this.userSession();
        this.getProductsCart();
        this.loadColors();

    }

    componentDidUpdate(prevProps) {
        if (prevProps.logged !== this.props.logged) {
            this.setState({
                logged: this.props.logged
            })
        }
    }

    render() {
        try {
            require('./css/cart.css');
            const { message_load, loaded, products, total_price, zip_code, orders_available, observation, fare_price, loadingFare, loadingCupom, cupom, cupom_error, quinzena } = this.state;
            
            console.log(total_price);
            
            return (
                <Loading message={message_load} loaded={loaded}>
                    <div className={`cart-container container-fluid mt-5 pt-md-4 pb-4 mb-5 ${loaded === true && 'show'}`}>
                        <main className='h-100'>
                            <div className='wrapper-table-cart'>
                                {products.length > 0 && this.loadProduct()}
                                {products.length > 0 && <div className='mb-4'></div>}
                                {products.length === 0 && <NotFound title='none_product_added' description='none_product_in_cart' />}
                                {products.length > 0 &&
                                    <div className='row mb-4 justify-content-end'>
                                        <div className='col-auto h6 text-left'>{getMessage('cupom_shopping')}: </div>
                                        <div className='col-auto'>
                                            <input type='text' className='input-zip-cart text-uppercase' value={cupom} onChange={(e) => this.handleChangeCupom(e.target.value)} />
                                            {loadingCupom === true &&
                                                <div className='ring-2'>
                                                    <div className='ball-holder'>
                                                        <div className='ball'></div>
                                                    </div>
                                                </div>}
                                        </div> 
                                    </div>}

                                   {products.length > 0 && 
                                     <div className='row mb-4 justify-content-end'>
                                      <div className='col-auto h6 text-left'>Agendar entrega:</div>
                                      <div className="col-auto style_wrapper">
                                        <Select 
                                         components={animatedComponents}
                                         options={this.scheduling()}
                                         value={quinzena}
                                         onChange={this.onChangeSelect}
                                        />
                                        </div>
                                    </div>}  

                                    {products.length > 0 &&
                                    <div className="observation_wrapper">
                                    <div className="mb-10">
                                        <div className='col-auto h4'>Observações</div>
                                        <div className="form-group">
                                          <textarea
                                            rows="8"
                                            className="form-control"
                                            value={observation}
                                            onChange={this.observationChange}
                                          ></textarea>
                                        </div>
                                    </div>
                                    </div>
                                } 

                                {/**products.length > 0 &&
                                    <div className='row mb-4 justify-content-end'>
                                        <div className='col-auto h6 text-left'>{getMessage('getting_shop')}: </div>
                                        <div className='col-auto'>
                                            <select name='deliveryMode' className='form-control' name='deliveryMode' value={this.state.deliveryMode} onChange={(e) => {
                                                this.handleChange({
                                                    target: {
                                                        name: 'deliveryMode',
                                                        value: e.target.value
                                                    }
                                                });
                                            }}>
                                                <option value='0'>{getMessage('not')}</option>
                                                <option value='1'>{getMessage('yes')}</option>
                                            </select>
                                        </div>
                                        </div>**/}

                                {(products.length > 0 && this.state.deliveryMode === '0') &&
                                    <div className='row mb-4 justify-content-end'>
                                        <div className='col-auto h6 text-left'>{getMessage('type_cep_address')}: </div>
                                        <div className='col-auto'>
                                            <InputMask mask="99999-999" className='input-zip-cart' value={zip_code} onChange={(e) => this.handleChangeZip(e.target.value)} />
                                            {loadingFare === true &&
                                                <div className='ring-2'>
                                                    <div className='ball-holder'>
                                                        <div className='ball'></div>
                                                    </div>
                                                </div>}
                                        </div>
                                    </div>}
                                {products.length > 0 &&
                                    <div className='row mb-4 justify-content-end'>
                                        {
                                            zip_code.match(/\d/g) && zip_code.match(/\d/g).join('').length === 8 && orders_available === false &&
                                            <div className='mt-3 alert alert-warning'>{getMessage('unavailable_to_shopping')}</div>
                                        }
                                    </div>
                                }
                                {products.length > 0 &&
                                    <div className='row mb-4 justify-content-end'>
                                        {cupom_error.length > 0 && <div className='mt-2 alert alert-warning'>{getMessage(cupom_error || 'cupom_expired')}</div>}
                                    </div>
                                }
                                {/**products.length > 0 &&
                                    <div className='table-cart-middle row justify-content-end mb-2'>
                                        <div className='col-auto col-sm-auto col-md-auto'>
                                            <h3 className='h5'>{getMessage('freight_fare')}</h3>
                                        </div>
                                        <div className='col-8 col-sm-auto text-right'>
                                            <h3 className='h5'>
                                                <strong>{currencyFormatter.format(fare_price, { locale: 'pt-BR' })}</strong>
                                            </h3>
                                        </div>
                                    </div>
                                **/}
                                {products.length > 0 &&
                                <div className="container_wrapper">
                                    <div className='table-cart-middle row justify-content-end mb-2'>
                                        <div className='col-auto col-sm-auto col-md-auto'>
                                            <h3 className='h5'>{getMessage('discount')}</h3>
                                        </div>
                                        <div className='col-8 col-sm-auto text-right'>
                                            <h3 className='h5'>
                                                <strong>{currencyFormatter.format(this.calcTotalDiscount(total_price), { locale: 'pt-BR' })}</strong>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                }
                                {products.length > 0 &&
                                <div className="container_wrapper"> 
                                    <div className='table-cart-middle row justify-content-end mb-2'>
                                        <div className='col-auto col-sm-auto col-md-auto'>
                                            <h3>{getMessage('total')}</h3>
                                        </div>
                                        <div className='col-8 col-sm-auto text-right'>
                                            <h3>
                                                <strong>{currencyFormatter.format(this.calcTotalPrice(total_price) + fare_price, { locale: 'pt-BR' })}</strong>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                            {products.length > 0 &&
                            <div className="container_wrapper">
                                <div className='footer-cart text-right'>
                                    <button type='button' className='btn btn-default ml-2 mr-2' onClick={this.goToHome}>{getMessage('continue_to_shopping')}</button>
                                    {orders_available === true && <button type='button' className='btn btn-success ml-2 mr-2' onClick={this.seePayment}>{getMessage('checkout')}</button>}
                                </div>
                            </div>
                            }
                        </main>
                    </div>
                    <Footer />
                </Loading>
            )
        }
        catch (error) {
            return <div className='text-center h1 p-5 m-auto'>{error.message}</div>;
        }
    }
}
export default withAlert()(withRouter(connect(store => ({ products: store.products, user: store.user }))(ShoppingCart)));